export default __webpack_public_path__ + "static/media/uploader-animas-3.a5d15e2f.png";